// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AuthState } from '@app/core';
import { routerReducer } from '@ngrx/router-store';
import { authReducer } from './auth.reducer';
import { alertsReducer, AlertsModel } from './alerts.reducer';
import { permissionsReducer, canAccessRoute, getAllowedRoutes, PermissionsState } from './permissions.reducer';
import { MetaEffects } from '@app/core/state/meta.effects';
import { AuthEffects } from './auth.effects';
import { RouterEffects } from './router.effects';
import { SentryEffects } from './sentry.effects';
import { projectsReducer, ProjectsState, getProjectDetails } from './projects.reducer';
import { ProjectsEffects } from '@app/core/state/projects.effects';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { loggedUserReducer, LoggerUserReducer } from './logged-user';
import { LoggedUserEffects } from './logged-user/logged-user.effect';

export * from './router.actions';
export * from './auth.actions';
export * from './auth.reducer';
export * from './projects.effects';
export * from './projects.actions';
export * from './projects.reducer';
export * from './permissions.reducer';
export * from './alerts.actions';
export * from './alerts.reducer';

export { STORAGE_TOKEN } from './auth.effects';
export const effects = [
  AuthEffects,
  RouterEffects,
  // SentryEffects,
  MetaEffects,
  ProjectsEffects,
  LoggedUserEffects
];

export const PROJECTS_FEATURE_NAME = 'projects';

export const projectsSelector = createFeatureSelector<ProjectsState>(PROJECTS_FEATURE_NAME);
export const selectProjectDetails = (projectId: string) =>
  createSelector(projectsSelector, getProjectDetails(projectId));

export const MEMBERSHIPS_FEATURE_NAME = 'memberships';

export const membershipsSelector = createFeatureSelector<CoreState>(MEMBERSHIPS_FEATURE_NAME);

export const selectUserAccountId = createSelector(membershipsSelector, () => 'placeholderAccountId');

export const PERMISSIONS_FEATURE_NAME = 'permissions';

export const permissionsSelector = createFeatureSelector<PermissionsState>(PERMISSIONS_FEATURE_NAME);

export const selectCanAccessRoute = (route: string) => createSelector(permissionsSelector, canAccessRoute(route));

export const selectAllowedRoutes = createSelector(permissionsSelector, getAllowedRoutes);

export interface CoreState {
  auth: AuthState;
  alerts: AlertsModel;
  projects: ProjectsState;
  permissions: PermissionsState;
  loggedUser: LoggerUserReducer;
}

export const reducers = {
  auth: authReducer,
  alerts: alertsReducer,
  router: routerReducer,
  projects: projectsReducer,
  permissions: permissionsReducer,
  loggedUser: loggedUserReducer
};



// WEBPACK FOOTER //
// ./src/app/core/state/index.ts